<template lang="html">
    <v-form v-model="isValid" ref="form" @submit.prevent=''>
        <v-layout wrap>
            <v-flex xs12>
                <v-text-field label="Nouveau mot de passe" type="password" ref="input" v-model="newPassword" :rules="rules.Password" required></v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field label="Confirmer le nouveau mot de passe" type="password" v-model="newPassword2" :rules="rules.confirmPass" required></v-text-field>
            </v-flex>
       </v-layout>
    </v-form>
</template>

<script>
    import Avatar from '../../../../components/avatar/Avatar.vue'
    export default {
        components: { Avatar },

        data() {
            return {
                title:      'Réinitialiser le mot de passe',
                icon:       'vpn_key',

                isValid:    false,
                newPassword: '',
                newPassword2: '',
                rules: {
                    Password: [
                        (v) => !!v || 'Mot de passe obligatoire',
                        function (v){
                            let rstr = null
                            if(!/^(?=.*[a-z])[A-Za-z\d$@$!%*?&]{8,}$/.test(v)){
                                rstr = 'Le mot de passe doit contenir au moins 8 caractères'
                            }
                            if(!/^(?=.*[A-Z])/.test(v)) {
                                if (!rstr){
                                    rstr = 'Le mot de passe doit contenir au moins une majuscule'
                                } else {
                                    rstr += ', au moins une majuscule'
                                }
                            }
                            if(!/^(?=.*\d)/.test(v)) {
                                if (!rstr){
                                    rstr = 'Le mot de passe doit contenir au moins 1 chiffre'
                                } else {
                                    rstr += ', au moins 1 chiffre'
                                }
                            }
                            if(/^(?=.*[$@$!%*?&])/.test(v)){
                                if (!rstr){
                                    rstr = 'Le mot de passe ne doit pas contenir de caractère spéciaux'
                                } else {
                                    rstr += 'et ne doit pas contenir de caractère spéciaux'
                                }
                            }
                            if(rstr) {
                                return rstr
                            } else {
                                return true
                            }
                        }
                    ],
                    confirmPass: [
                        (v) => !!v || 'Confirmation de mot de passe obligatoire',
                        (v) => v == this.newPassword || 'Les mots de passe ne correspondent pas'
                    ]
                }
            }
        },

        methods: {
            onClose() {
                if(this.$refs.form){
                    this.$refs.form.reset()
                }

                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.$refs.form.validate()) {
                    this.axios.put(`/api/users/${this.$store.state.single.data.id}/password`, { password:this.newPassword2 })
                        .then(response => {
                            this.$eventHub.$emit('open-snackbar', 'primary','Le mot de passe à bien été mis à jour')
                            this.$eventHub.$emit('close-modal')
                            this.$refs.form.reset()
                        })
                        .catch(error => {
                            this.$eventHub.$emit('open-snackbar', 'error','Le mot de passe n\'à pas pu être mis à jour')
                        })
                } else {
                    return false
                }
            }
        },

        mounted() {

            this.$nextTick(()=> this.$refs.input.$refs.input.focus())
        }

    }
</script>

<style lang="stylus">
.chip__content {
    .avatar {
        margin-right: 0
    }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/users/single/ResetPassword.vue